import type { ChartData } from 'chart.js'

import { BarChart } from '@/components/charts/bar-chart.tsx'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card.tsx'
import { Skeleton } from '@/components/ui/skeleton.tsx'

interface BestTimeChartProps {
  title: string
  data?: ChartData<'bar', (number | [number, number] | null)[], unknown>
  isFetching?: boolean
  showCents?: boolean
}

export const BestTimeChart = ({
  title,
  data,
  isFetching,
  showCents,
}: BestTimeChartProps) => {
  return isFetching ? (
    <Card>
      <CardHeader>
        <Skeleton className="h-[35px] w-1/3" />
      </CardHeader>
      <CardContent>
        <Skeleton className="h-[300px] w-full" />
      </CardContent>
    </Card>
  ) : (
    <Card className="flex flex-col xl:justify-between">
      <CardHeader>
        <CardTitle className="text-xl font-semibold leading-none text-text-default">
          <div className="flex w-full justify-between">{title}</div>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {data && (
          <BarChart
            data={data}
            toggleOptions={{ isTooltipCurrency: true }}
            showCents={showCents}
          />
        )}
      </CardContent>
    </Card>
  )
}
